import { combineReducers } from 'redux';
import { firebaseReducer } from 'react-redux-firebase';
import { createResponsiveStateReducer } from 'redux-responsive';

import addWish from './addWish/reducer';
import deleteWish from './deleteWish/reducer';
import dialogs from './dialogs/reducer';
import editWish from './editWish/reducer';
import language from './language/reducer';
import sidebar from './sidebar/reducer';
import wishes from './wishes/reducer';

export default combineReducers({
  addWish,
  browser: createResponsiveStateReducer({
    extraSmall: 480,
    smallish: 730,
    small: 768,
    medium: 992,
    large: 1200,
  }),
  deleteWish,
  dialogs,
  editWish,
  firebase: firebaseReducer,
  language,
  sidebar,
  wishes
});



// WEBPACK FOOTER //
// ./src/store/reducers.js